module.exports = __webpack_public_path__ + "static/media/buffet6.0fefca68.jpg";